var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobalLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.75a1 1 0 011 1v1.104a1 1 0 01-2 0V11.75a1 1 0 011-1z",
    fill: "#000064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a4 4 0 014 4v3h1.5l.256.013A2.5 2.5 0 0116 9.5v6l-.013.256A2.5 2.5 0 0113.5 18h-11a2.5 2.5 0 01-2.487-2.244L0 15.5v-6a2.5 2.5 0 012.244-2.487L2.5 7H4V4a4 4 0 014-4zM2.5 8.8a.7.7 0 00-.7.7v6a.7.7 0 00.7.7h11a.7.7 0 00.7-.7v-6a.7.7 0 00-.7-.7h-11zm5.5-7A2.2 2.2 0 005.8 4v2.997h4.4V4A2.2 2.2 0 008 1.8z",
    fill: "#000064"
  })));
}
export default SvgIconGlobalLogin;